import Vue, {PluginObject} from 'vue';
import CommonReasonDialog from '@/components/dialog/CommonReasonDialog.vue';
import AuditTrailDialog from '@/components/dialog/AuditTrailDialog.vue';
import ItemAuditTrailDialog from '@/components/dialog/ItemAuditTrailDialog.vue';
import {
    AiCodingUpdateConfirmDialogRequest, ProductRecommendedCodeInfoDialogRequest,
    AuditTrailDialogRequest,
    AvailableToDownloadReportData,
    CaseEmailLogDetailDialogRequest,
    CaseProductSelectDialogRequest,
    CDMSItemSelectDialogRequest,
    CommonConfirmDialogRequest,
    CommonReasonDialogRequest,
    CommonSelectDialogRequest,
    DataSelectLibraryDialogRequest,
    DiscardConfirmDialogRequest,
    DuplicatedCaseDialogRequest,
    FileUploadDialogRequest,
    ItemAuditTrailDialogRequest,
    KcdSelectDialogRequest,
    KimsSelectDialogRequest,
    MeddraSelectDialogRequest,
    MfdsProductSelectDialogRequest,
    MfdsSubstanceSelectDialogRequest,
    MultipleProductsSelectDialogRequest,
    MultipleSendersSelectDialogRequest,
    MultipleStudiesSelectDialogRequest,
    ProductSelectDialogRequest,
    ReceiverSelectDialogRequest,
    ReporterSelectDialogRequest,
    SenderSelectDialogRequest,
    SponsorSelectDialogRequest,
    StudySelectDialogRequest,
    SubmissionCommentUpdateDialogRequest,
    SubmissionConfirmDialogRequest,
    SyncCdmsStudySelectDialogRequest,
    SyncCubeCDMSItemData,
    SyncR3StudySelectDialogRequest,
    WhoartSelectDialogRequest,
    WhoddCasSelectDialogRequest,
    WhoddSelectDialogRequest,
    MultipleRolesSelectDialogRequest,
    CaseNarrativeSelectDialogRequest,
    CaseIdfSelectDialogRequest,
    MakeEditorTableDialogRequest,
    InputUrlDialogRequest,
    PopupNoticesDialogRequest,
    CaseUniiDictionaryDialogRequest,
    CaseNsdeDictionaryDialogRequest,
    CaseDeviceProblemCodeDictionaryDialogRequest,
    CaseDeviceComponentCodeDictionaryDialogRequest, SyncOptionsDialogRequest, CaseWorkflowBatchUpdateDialogRequest,
    WhoddSubstanceRecommendedCodeInfoDialogRequest, MfdsProductRecommendedCodeInfoDialogRequest,
    MfdsSubstanceRecommendedCodeInfoDialogRequest
} from '@/model/CommonModel';
import DiscardConfirmDialog from '@/components/dialog/DiscardConfirmDialog.vue';
import SessionTimeoutWarningDialog from '@/components/dialog/SessionTimeoutWarningDialog.vue';
import FileUploadDialog from '@/components/dialog/FileUploadDialog.vue';
import CommonConfirmDialog from '@/components/dialog/CommonConfirmDialog.vue';
import CaseEmailLogDetailDialog from '@/views/case/CaseEmailLogDetailDialog.vue';
import DataSelectLibraryDialog from '@/views/data/DataSelectLibraryDialog.vue';
import CaseReportEmailDialog from '@/views/case/CaseReportEmailDialog.vue';
import CaseReportDownloadDialog from '@/views/case/CaseReportDownloadDialog.vue';
import SelectCDMSItemDialog from '@/views/sync/SelectCDMSItemDialog.vue';
import ReporterSelectDialog from '@/components/dialog/ReporterSelectDialog.vue';
import ReceiverSelectDialog from '@/components/dialog/ReceiverSelectDialog.vue';
import ProductSelectDialog from '@/components/dialog/ProductSelectDialog.vue';
import MultipleProductsSelectDialog from '@/components/dialog/MultipleProductsSelectDialog.vue';
import MultipleStudiesSelectDialog from '@/components/dialog/MultipleStudiesSelectDialog.vue';
import SyncCdmsStudySelectDialog from '@/components/dialog/SyncCdmsStudySelectDialog.vue';
import SyncR3StudySelectDialog from '@/components/dialog/SyncR3StudySelectDialog.vue';
import SenderSelectDialog from '@/components/dialog/SenderSelectDialog.vue';
import MultipleSendersSelectDialog from '@/components/dialog/MultipleSendersSelectDialog.vue';
import SponsorSelectDialog from '@/views/login/SponsorSelectDialog.vue';
import SyncSelectDialog from '@/views/sync/SyncSelectDialog.vue';
import CaseKcdSelectDialog from '@/components/dialog/CaseKcdSelectDialog.vue';
import CaseMeddraSelectDialog from '@/components/dialog/CaseMeddraSelectDialog.vue';
import CaseWhoartSelectDialog from '@/components/dialog/CaseWhoartSelectDialog.vue';
import StudySelectDialog from '@/components/dialog/StudySelectDialog.vue';
import CaseKimsSelectDialog from '@/components/dialog/CaseKimsSelectDialog.vue';
import CaseMfdsProductSelectDialog from '@/components/dialog/CaseMfdsProductSelectDialog.vue';
import DuplicatedCaseDialog from '@/components/dialog/DuplicatedCaseDialog.vue';
import CaseProductSelectDialog from '@/components/dialog/CaseProductSelectDialog.vue';
import CaseMfdsSubstanceSelectDialog from '@/components/dialog/CaseMfdsSubstanceSelectDialog.vue';
import CaseDeleteReasonDialog from '@/components/dialog/CaseDeleteReasonDialog.vue';
import CaseCommonSelectDialog from '@/components/dialog/CaseCommonSelectDialog.vue';
import CommonSelectDialog from '@/components/dialog/CommonSelectDialog.vue';
import WhoddDialog from '@/views/0exam/WhoddDialog.vue';
import CaseWhoddSelectDialog from '@/components/dialog/CaseWhoddSelectDialog.vue';
import CaseWhoddCasSelectDialog from '@/components/dialog/CaseWhoddCasSelectDialog.vue';
import SubmissionConfirmDialog from '@/components/dialog/SubmissionConfirmDialog.vue';
import SubmissionCommentUpdateDialog from '@/components/dialog/SubmissionCommentUpdateDialog.vue';
import MultipleRolesSelectDialog from '@/components/dialog/MultipleRolesSelectDialog.vue';
import CaseNarrativeSelectDialog from '@/components/dialog/CaseNarrativeSelectDialog.vue';
import CaseIdfSelectDialog from '@/components/dialog/CaseIdfSelectDialog.vue';
import MakeEditorTableDialog from '@/components/dialog/MakeEditorTableDialog.vue';
import InputUrlDialog from '@/components/dialog/InputUrlDialog.vue';
import ResetSyncConfirmDialog from '@/components/dialog/ResetSyncConfirmDialog.vue';
import PopupNoticesDialog from '@/components/dialog/PopupNoticesDialog.vue';
import CaseNsdeSelectDialog from '@/components/dialog/CaseNsdeSelectDialog.vue';
import CaseUniiSelectDialog from '@/components/dialog/CaseUniiSelectDialog.vue';
import CaseDeviceProblemCodeSelectDialog from '@/components/dialog/CaseDeviceProblemCodeSelectDialog.vue';
import CaseDeviceComponentCodeSelectDialog from '@/components/dialog/CaseDeviceComponentCodeSelectDialog.vue';
import SyncOptionsDialog from '@/components/dialog/SyncOptionsDialog.vue';
import AiCodingUpdateConfirmDialog from '@/components/dialog/AiCodingUpdateConfirmDialog.vue';
import ProductRecommendedCodeInfoDialog from '@/components/dialog/ProductRecommendedCodeInfoDialog.vue';
import CaseWorkflowBatchUpdateDialog from '@/components/dialog/CaseWorkflowBatchUpdateDialog.vue';
import WhoddSubstanceRecommendedCodeInfoDialog from '@/components/dialog/WhoddSubstanceRecommendedCodeInfoDialog.vue';
import MfdsProductRecommendedCodeInfoDialog from '@/components/dialog/MfdsProductRecommendedCodeInfoDialog.vue';
import MfdsSubstanceRecommendedCodeInfoDialog from '@/components/dialog/MfdsSubstanceRecommendedCodeInfoDialog.vue';

declare module 'vue/types/vue' {
    interface Vue {
        $modal: ModalService;
    }
}

export interface ModalService {
    showMultipleRolesSelectDialog(params: MultipleRolesSelectDialogRequest): void;
    
    hideMultipleRolesSelectDialog(): void;
    
    showReasonDialog(params: CommonReasonDialogRequest): void;

    hideReasonDialog(): void;

    showAuditTrailDialog(params: AuditTrailDialogRequest): void;

    hideAuditTrailDialog(): void;

    showItemAuditTrailDialog(params: ItemAuditTrailDialogRequest): void;

    hideItemAuditTrailDialog(): void;

    showDiscardConfirmDialog(params: DiscardConfirmDialogRequest): void;

    showSessionTimeoutWarningDialog(): void;

    showSponsorSelectDialog(request: SponsorSelectDialogRequest): void;

    hideSponsorSelectDialog(): void;

    showFileUploadDialog(request: FileUploadDialogRequest): void;

    hideFileUploadDialog(): void;

    showCommonConfirmDialog(request: CommonConfirmDialogRequest): void;

    hideCommonConfirmDialog(): void;

    showCaseEmailLogDetailDialog(request: CaseEmailLogDetailDialogRequest): void;

    hideCaseEmailLogDetailDialog(): void;

    showDataSelectLibraryDialog(request: DataSelectLibraryDialogRequest): void;

    hideDataSelectLibraryDialog(): void;

    showCaseReportEmailDialog(params: AvailableToDownloadReportData): void;

    hideCaseReportEmailDialog(): void;

    showCaseReportDownloadDialog(params: AvailableToDownloadReportData): void;

    showCDMSItemTreeDialog(params: CDMSItemSelectDialogRequest): void;

    hideCDMSItemTreeDialog(): void;

    hideCaseReportDownloadDialog(): void;

    showReporterSelectDialog(params: ReporterSelectDialogRequest): void;

    hideReporterSelectDialog(): void;

    showReceiverSelectDialog(params: ReceiverSelectDialogRequest): void;

    hideReceiverSelectDialog(): void;

    showProductSelectDialog(params: ProductSelectDialogRequest): void;

    hideProductSelectDialog(): void;

    showMultipleProductSelectDialog(params: MultipleProductsSelectDialogRequest): void;

    hideMultipleProductSelectDialog(): void;

    showMultipleStudiesSelectDialog(params: MultipleStudiesSelectDialogRequest): void;

    hideMultipleStudiesSelectDialog(): void;

    showSyncCdmsStudySelectDialog(params: SyncCdmsStudySelectDialogRequest): void;

    hideSyncCdmsStudySelectDialog(): void;

    showSyncR3StudySelectDialog(params: SyncR3StudySelectDialogRequest): void;

    hideSyncR3StudySelectDialog(): void;

    showSenderSelectDialog(params: SenderSelectDialogRequest): void;

    hideSenderSelectDialog(): void;

    showMultipleSendersSelectDialog(params: MultipleSendersSelectDialogRequest): void;

    hideMultipleSendersSelectDialog(): void;

    showSyncSelectDialog(params: SyncCubeCDMSItemData): void;

    hideSyncSelectDialog(): void;

    kcdSelectDialog(params: KcdSelectDialogRequest): void;

    hideKcdSelectDialog(): void;

    meddraSelectDialog(params: MeddraSelectDialogRequest): void;

    hideMeddraSelectDialog(): void;

    whoartSelectDialog(params: WhoartSelectDialogRequest): void;

    hideWhoartSelectDialog(): void;

    studySelectDialog(param: StudySelectDialogRequest): void;

    hideStudySelectDialog(): void;

    kimsSelectDialog(param: KimsSelectDialogRequest): void;

    hideKimsSelectDialog(): void;

    mfdsProductSelectDialog(param: MfdsProductSelectDialogRequest): void;

    hideMfdsProductSelectDialog(): void;

    showDuplicatedCasesDialog(param: DuplicatedCaseDialogRequest): void;

    hideDuplicatedCaseDialog(): void;

    caseProductSelectDialog(param: CaseProductSelectDialogRequest): void;

    hideCaseProductSelectDialog(): void;

    mfdsSubstanceSelectDialog(param: MfdsSubstanceSelectDialogRequest): void;

    hideMfdsSubstanceSelectDialog(): void;

    caseDeleteReasonDialog(param: CommonReasonDialogRequest): void;

    hideCaseDeleteReasonDialog(): void;

    showCaseCommonSelectDialog(param: CommonSelectDialogRequest): void;

    hideCaseCommonSelectDialog(): void;

    showCommonSelectDialog(param: CommonSelectDialogRequest): void;

    hideCommonSelectDialog(): void;

    showWhoddSelectDialog(): void;

    hideWhoddSelectDialog(): void;

    showCaseWhoddSelectDialog(param: WhoddSelectDialogRequest): void;
    
    hideCaseWhoddSelectDialog(): void;
    
    showCaseWhoddCasSelectDialog(param: WhoddCasSelectDialogRequest): void;
    
    hideCaseWhoddCasSelectDialog(): void;
    
    showSubmissionConfirmDialog(param: SubmissionConfirmDialogRequest): void;
    
    hideSubmissionConfirmDialog(): void;
    
    showSubmissionCommentUpdateDialog(param: SubmissionCommentUpdateDialogRequest): void;
    
    hideSubmissionCommentUpdateDialog(): void;

    showCaseNarrativeSelectDialog(param: CaseNarrativeSelectDialogRequest): void;

    hideCaseNarrativeSelectDialog(): void;

    showMakeEditorTableDialog(param: MakeEditorTableDialogRequest): void;

    hideMakeEditorTableDialog(): void;

    showInputUrlDialog(param: InputUrlDialogRequest): void;

    hideInputUrlDialog(): void;
    
    getEventBus(): Vue;
    
    showCaseIdfSelectDialog(param: CaseIdfSelectDialogRequest): void;
    
    hideCaseIdfSelectDialog(): void;

    showResetSyncConfirmDialog(param: CommonReasonDialogRequest): void;

    hideResetSyncConfirmDialog(): void;

    showPopupNoticesDialog(param: PopupNoticesDialogRequest): void;

    hidePopupNoticesDialog(): void;
    
    showCaseNsdeSelectDialog(param: CaseNsdeDictionaryDialogRequest): void;
    
    hideCaseNsdeSelectDialog(): void;
    
    showCaseUniiSelectDialog(param: CaseUniiDictionaryDialogRequest): void;

    hideCaseUniiSelectDialog(): void;
    
    showCaseDeviceProblemCodeSelectDialog(param: CaseDeviceProblemCodeDictionaryDialogRequest): void;
    
    hideCaseDeviceProblemCodeSelectDialog(): void;
    
    showCaseDeviceComponentCodeSelectDialog(param: CaseDeviceComponentCodeDictionaryDialogRequest): void;

    hideCaseDeviceComponentCodeSelectDialog(): void;

    showSyncOptionsDialog(param: SyncOptionsDialogRequest): void;

    hideSyncOptionsDialog(): void;

    showAiCodingUpdateConfirmDialog(param: AiCodingUpdateConfirmDialogRequest): void;

    hideAiCodingUpdateConfirmDialog(): void;

    showProductRecommendedCodeInfoDialog(param: ProductRecommendedCodeInfoDialogRequest): void;

    showWhoddSubstanceRecommendedCodeInfoDialog(param: WhoddSubstanceRecommendedCodeInfoDialogRequest): void;

    hideProductRecommendedCodeInfoDialog(): void;

    showMfdsProductRecommendedCodeInfoDialog(param: MfdsProductRecommendedCodeInfoDialogRequest): void;

    hideMfdsProductRecommendedCodeInfoDialog(): void;

    showMfdsSubstanceRecommendedCodeInfoDialog(params: MfdsSubstanceRecommendedCodeInfoDialogRequest): void;

    hideMfdsSubstanceRecommendedCodeInfoDialog(): void;

    showCaseWorkflowBatchUpdateDialog(param: CaseWorkflowBatchUpdateDialogRequest): void;

    hideCaseWorkflowBatchUpdateDialog(): void;

}

interface DialogOptions {
}

export default class ModalServiceImpl
    implements PluginObject<DialogOptions>, ModalService {
    public eventBus = new Vue();

    public install(option: DialogOptions) {
        Vue.prototype.$modal = new ModalServiceImpl();
        Vue.component('multiple-roles-select-dialog', MultipleRolesSelectDialog);
        Vue.component('reason-dialog', CommonReasonDialog);
        Vue.component('audit-trail-dialog', AuditTrailDialog);
        Vue.component('item-audit-trail-dialog', ItemAuditTrailDialog);
        Vue.component('discard-confirm-dialog', DiscardConfirmDialog);
        Vue.component('sponsor-select-dialog', SponsorSelectDialog);
        Vue.component('session-timeout-warning-dialog', SessionTimeoutWarningDialog);
        Vue.component('file-upload-dialog', FileUploadDialog);
        Vue.component('common-confirm-dialog', CommonConfirmDialog);
        Vue.component('case-email-log-detail', CaseEmailLogDetailDialog);
        Vue.component('data-select-library-dialog', DataSelectLibraryDialog);
        Vue.component('case-report-email-dialog', CaseReportEmailDialog);
        Vue.component('case-report-download', CaseReportDownloadDialog);
        Vue.component('cdms-item-dialog', SelectCDMSItemDialog);
        Vue.component('reporter-select-dialog', ReporterSelectDialog);
        Vue.component('receiver-select-dialog', ReceiverSelectDialog);
        Vue.component('product-select-dialog', ProductSelectDialog);
        Vue.component('multiple-products-select-dialog', MultipleProductsSelectDialog);
        Vue.component('multiple-studies-select-dialog', MultipleStudiesSelectDialog);
        Vue.component('sync-cdms-study-select-dialog', SyncCdmsStudySelectDialog);
        Vue.component('sync-r3-study-select-dialog', SyncR3StudySelectDialog);
        Vue.component('sender-select-dialog', SenderSelectDialog);
        Vue.component('multiple-sender-select-dialog', MultipleSendersSelectDialog);
        Vue.component('sync-select-dialog', SyncSelectDialog);
        Vue.component('case-kcd-select-dialog', CaseKcdSelectDialog);
        Vue.component('case-meddra-select-dialog', CaseMeddraSelectDialog);
        Vue.component('case-whoart-select-dialog', CaseWhoartSelectDialog);
        Vue.component('study-select-dialog', StudySelectDialog);
        Vue.component('case-kims-select-dialog', CaseKimsSelectDialog);
        Vue.component('case-mfds-product-select-dialog', CaseMfdsProductSelectDialog);
        Vue.component('duplicated-case-dialog', DuplicatedCaseDialog);
        Vue.component('case-product-select-dialog', CaseProductSelectDialog);
        Vue.component('case-mfds-substance-select-dialog', CaseMfdsSubstanceSelectDialog);
        Vue.component('case-delete-reason-dialog', CaseDeleteReasonDialog);
        Vue.component('case-common-select-dialog', CaseCommonSelectDialog);
        Vue.component('common-select-dialog', CommonSelectDialog);
        Vue.component('whodd-dialog', WhoddDialog);
        Vue.component('case-whodd-select-dialog', CaseWhoddSelectDialog);
        Vue.component('case-whodd-cas-select-dialog', CaseWhoddCasSelectDialog);
        Vue.component('submission-confirm-dialog', SubmissionConfirmDialog);
        Vue.component('submission-update-dialog', SubmissionCommentUpdateDialog);
        Vue.component('case-narrative-select-dialog', CaseNarrativeSelectDialog);
        Vue.component('case-idf-select-dialog', CaseIdfSelectDialog);
        Vue.component('make-editor-table-dialog', MakeEditorTableDialog);
        Vue.component('input-url-dialog', InputUrlDialog);
        Vue.component('reset-sync-confirm-dialog', ResetSyncConfirmDialog);
        Vue.component('popup-notice-dialog', PopupNoticesDialog);
        Vue.component('case-nsde-select-dialog', CaseNsdeSelectDialog);
        Vue.component('case-unii-select-dialog', CaseUniiSelectDialog);
        Vue.component('case-device-problem-code-select-dialog', CaseDeviceProblemCodeSelectDialog);
        Vue.component('case-device-component-code-select-dialog', CaseDeviceComponentCodeSelectDialog);
        Vue.component('sync-options-dialog', SyncOptionsDialog);
        Vue.component('ai-coding-update-confirm-dialog', AiCodingUpdateConfirmDialog);
        Vue.component('product-recommended-code-info-dialog', ProductRecommendedCodeInfoDialog);
        Vue.component('whodd-substance-recommended-code-info-dialog', WhoddSubstanceRecommendedCodeInfoDialog);
        Vue.component('mfds-product-recommended-code-info-dialog', MfdsProductRecommendedCodeInfoDialog);
        Vue.component('mfds-substance-recommended-code-info-dialog', MfdsSubstanceRecommendedCodeInfoDialog);
        Vue.component('case-workflow-batch-update-dialog', CaseWorkflowBatchUpdateDialog);
    }
    
    public showMultipleRolesSelectDialog(params: MultipleRolesSelectDialogRequest) {
        this.eventBus.$emit('multipleRolesSelectDialog', params);
    }
    
    public hideMultipleRolesSelectDialog() {
        this.eventBus.$emit('hideMultipleRolesSelectDialog');
    }
    
    public showAuditTrailDialog(params: AuditTrailDialogRequest) {
        this.eventBus.$emit('showAuditTrailDialog', params);
    }

    public hideAuditTrailDialog() {
        this.eventBus.$emit('hideAuditTrailDialog');
    }

    public showItemAuditTrailDialog(params: ItemAuditTrailDialogRequest) {
        this.eventBus.$emit('showItemAuditTrailDialog', params);
    }

    public hideItemAuditTrailDialog() {
        this.eventBus.$emit('hideItemAuditTrailDialog');
    }

    public showReasonDialog(params: CommonReasonDialogRequest) {
        this.eventBus.$emit('reasonDialog', params);
    }

    public hideReasonDialog() {
        this.eventBus.$emit('hideReasonDialog');
    }

    public showDiscardConfirmDialog(paramse: DiscardConfirmDialogRequest) {
        this.eventBus.$emit('showDiscardConfirmDialog', paramse);
    }

    public showSessionTimeoutWarningDialog() {
        this.eventBus.$emit('showSessionTimeoutWarningDialog');
    }

    public showSponsorSelectDialog(request: SponsorSelectDialogRequest) {
        this.eventBus.$emit('showSponsorSelectDialog', request);
    }

    public hideSponsorSelectDialog() {
        this.eventBus.$emit('hideSponsorSelectDialog');
    }

    public showFileUploadDialog(request: FileUploadDialogRequest) {
        this.eventBus.$emit('fileUpload', request);
    }

    public hideFileUploadDialog() {
        this.eventBus.$emit('hideFileUploadDialog');
    }

    public showCommonConfirmDialog(request: CommonConfirmDialogRequest) {
        this.eventBus.$emit('showCommonConfirmDialog', request);
    }

    public hideCommonConfirmDialog() {
        this.eventBus.$emit('hideCommonConfirmDialog');
    }

    public showCaseEmailLogDetailDialog(request: CaseEmailLogDetailDialogRequest) {
        this.eventBus.$emit('emailLogDetail', request);
    }

    public hideCaseEmailLogDetailDialog() {
        this.eventBus.$emit('hideCaseEmailLogDetailDialog');
    }

    public showDataSelectLibraryDialog(request: DataSelectLibraryDialogRequest) {
        this.eventBus.$emit('showDataSelectLibraryDialog', request);
    }

    public hideDataSelectLibraryDialog() {
        this.eventBus.$emit('hideDataSelectLibraryDialog');
    }

    public showCaseReportEmailDialog(params: AvailableToDownloadReportData) {
        this.eventBus.$emit('caseReportEmailDialog', params);
    }

    public hideCaseReportEmailDialog() {
        this.eventBus.$emit('hideCaseReportEmailDialog');
    }

    public showCaseReportDownloadDialog(params: AvailableToDownloadReportData) {
        this.eventBus.$emit('caseReportDownloadDialog', params);
    }

    public hideCaseReportDownloadDialog() {
        this.eventBus.$emit('hideCaseReportDownloadDialog');
    }

    public showCDMSItemTreeDialog(params: CDMSItemSelectDialogRequest) {
        this.eventBus.$emit('showCDMSItemTreeDialog', params);
    }

    public hideCDMSItemTreeDialog() {
        this.eventBus.$emit('hideCDMSItemTreeDialog');
    }

    public showReporterSelectDialog(params: ReporterSelectDialogRequest) {
        this.eventBus.$emit('reporterSelectDialog', params);
    }

    public hideReporterSelectDialog() {
        this.eventBus.$emit('hideReporterSelectDialog');
    }

    public showReceiverSelectDialog(params: ReceiverSelectDialogRequest) {
        this.eventBus.$emit('receiverSelectDialog', params);
    }

    public hideReceiverSelectDialog() {
        this.eventBus.$emit('hideReceiverSelectDialog');
    }

    public showProductSelectDialog(params: ProductSelectDialogRequest) {
        this.eventBus.$emit('productSelectDialog', params);
    }

    public hideProductSelectDialog() {
        this.eventBus.$emit('hideProductSelectDialog');
    }

    public showMultipleProductSelectDialog(params: MultipleProductsSelectDialogRequest) {
        this.eventBus.$emit('multipleProductsSelectDialog', params);
    }

    public hideMultipleProductSelectDialog() {
        this.eventBus.$emit('hideMultipleProductSelectDialog');
    }

    public showMultipleStudiesSelectDialog(params: MultipleStudiesSelectDialogRequest) {
        this.eventBus.$emit('multipleStudiesSelectDialog', params);
    }

    public hideMultipleStudiesSelectDialog() {
        this.eventBus.$emit('hideMultipleStudiesSelectDialog');
    }

    public showSyncCdmsStudySelectDialog(params: SyncCdmsStudySelectDialogRequest) {
        this.eventBus.$emit('syncCdmsStudySelectDialog', params);
    }

    public hideSyncCdmsStudySelectDialog() {
        this.eventBus.$emit('hideSyncCdmsStudySelectDialog');
    }

    public showSyncR3StudySelectDialog(params: SyncR3StudySelectDialogRequest) {
        this.eventBus.$emit('syncR3StudySelectDialog', params);
    }

    public hideSyncR3StudySelectDialog() {
        this.eventBus.$emit('hideSyncR3StudySelectDialog');
    }

    public showSenderSelectDialog(params: SenderSelectDialogRequest) {
        this.eventBus.$emit('senderSelectDialog', params);
    }

    public hideSenderSelectDialog() {
        this.eventBus.$emit('hideSenderSelectDialog');
    }

    public showMultipleSendersSelectDialog(params: MultipleSendersSelectDialogRequest) {
        this.eventBus.$emit('multipleSendersSelectDialog', params);
    }

    public hideMultipleSendersSelectDialog() {
        this.eventBus.$emit('hideMultipleSendersSelectDialog');
    }

    public showSyncSelectDialog(params: SyncCubeCDMSItemData) {
        this.eventBus.$emit('syncSelectDialog', params);
    }

    public hideSyncSelectDialog() {
        this.eventBus.$emit('hideSyncSelectDialog');
    }

    public kcdSelectDialog(params: KcdSelectDialogRequest) {
        this.eventBus.$emit('kcdSelectDialog', params);
    }

    public hideKcdSelectDialog() {
        this.eventBus.$emit('hideKcdSelectDialog');
    }

    public meddraSelectDialog(params: MeddraSelectDialogRequest) {
        this.eventBus.$emit('meddraSelectDialog', params);
    }

    public hideMeddraSelectDialog() {
        this.eventBus.$emit('hideMeddraSelectDialog');
    }

    public whoartSelectDialog(params: WhoartSelectDialogRequest) {
        this.eventBus.$emit('whoartSelectDialog', params);
    }

    public hideWhoartSelectDialog() {
        this.eventBus.$emit('hideMeddraSelectDialog');
    }

    public studySelectDialog(params: StudySelectDialogRequest) {
        this.eventBus.$emit('studySelectDialog', params);
    }

    public hideStudySelectDialog() {
        this.eventBus.$emit('hideStudySelectDialog');
    }

    public kimsSelectDialog(param: KimsSelectDialogRequest) {
        this.eventBus.$emit('kimsSelectDialog', param);
    }

    public hideKimsSelectDialog() {
        this.eventBus.$emit('hideKimsSelectDialog');
    }

    public mfdsProductSelectDialog(param: MfdsProductSelectDialogRequest) {
        this.eventBus.$emit('mfdsProductSelectDialog', param);
    }

    public hideMfdsProductSelectDialog() {
        this.eventBus.$emit('hideMfdsProductSelectDialog');
    }

    public showDuplicatedCasesDialog(param: DuplicatedCaseDialogRequest) {
        this.eventBus.$emit('showDuplicatedCasesDialog', param);
    }

    public hideDuplicatedCaseDialog() {
        this.eventBus.$emit('hideDuplicatedCaseDialog');
    }

    public caseProductSelectDialog(params: CaseProductSelectDialogRequest) {
        this.eventBus.$emit('caseProductSelectDialog', params);
    }

    public hideCaseProductSelectDialog() {
        this.eventBus.$emit('hideCaseProductSelectDialog');
    }

    public mfdsSubstanceSelectDialog(param: MfdsSubstanceSelectDialogRequest) {
        this.eventBus.$emit('mfdsSubstanceSelectDialog', param);
    }

    public hideMfdsSubstanceSelectDialog() {
        this.eventBus.$emit('hideMfdsSubstanceSelectDialog');
    }

    public caseDeleteReasonDialog(param: CommonReasonDialogRequest) {
        this.eventBus.$emit('caseDeleteReasonDialog', param);
    }

    public hideCaseDeleteReasonDialog() {
        this.eventBus.$emit('hideCaseDeleteReasonDialog');
    }

    public showCaseCommonSelectDialog(param: CommonSelectDialogRequest) {
        this.eventBus.$emit('showCaseCommonSelectDialog', param);
    }

    public hideCaseCommonSelectDialog() {
        this.eventBus.$emit('hideCaseCommonSelectDialog');
    }

    public showCommonSelectDialog(param: CommonSelectDialogRequest) {
        this.eventBus.$emit('showCommonSelectDialog', param);
    }

    public hideCommonSelectDialog() {
        this.eventBus.$emit('hideCommonSelectDialog');
    }

    public showWhoddSelectDialog() {
        this.eventBus.$emit('showWhoddSelectDialog');
    }

    public hideWhoddSelectDialog() {
        this.eventBus.$emit('hideWhoddSelectDialog');
    }

    public showCaseWhoddSelectDialog(param: WhoddSelectDialogRequest) {
        this.eventBus.$emit('showCaseWhoddSelectDialog', param);
    }

    public hideCaseWhoddSelectDialog() {
        this.eventBus.$emit('hideCaseWhoddSelectDialog');
    }

    public showCaseWhoddCasSelectDialog(param: WhoddCasSelectDialogRequest) {
        this.eventBus.$emit('showCaseWhoddCasSelectDialog', param);
    }

    public hideCaseWhoddCasSelectDialog() {
        this.eventBus.$emit('hideCaseWhoddCasSelectDialog');
    }
    
    public showSubmissionConfirmDialog(param: SubmissionConfirmDialogRequest) {
        this.eventBus.$emit('showSubmissionConfirmDialog', param);
    }
    
    public hideSubmissionConfirmDialog() {
        this.eventBus.$emit('hideSubmissionConfirmDialog');
    }
    
    public showSubmissionCommentUpdateDialog(param: SubmissionCommentUpdateDialogRequest) {
        this.eventBus.$emit('showSubmissionCommentUpdateDialog', param);
    }
    
    public hideSubmissionCommentUpdateDialog() {
        this.eventBus.$emit('hideSubmissionCommentUpdateDialog');
    }

    public showCaseNarrativeSelectDialog(param: CaseNarrativeSelectDialogRequest) {
        this.eventBus.$emit('showCaseNarrativeSelectDialog', param);
    }

    public hideCaseNarrativeSelectDialog() {
        this.eventBus.$emit('hideCaseNarrativeSelectDialog');
    }
    
    public showCaseIdfSelectDialog(param: CaseIdfSelectDialogRequest) {
        this.eventBus.$emit('showCaseIdfSelectDialog', param);
    }
    
    public hideCaseIdfSelectDialog() {
        this.eventBus.$emit('hideCaseIdfSelectDialog');
    }

    public showMakeEditorTableDialog(param: MakeEditorTableDialogRequest) {
        this.eventBus.$emit('showMakeEditorTableDialog', param);
    }

    public hideMakeEditorTableDialog() {
        this.eventBus.$emit('hideMakeEditorTableDialog');
    }

    public showInputUrlDialog(param: InputUrlDialogRequest) {
        this.eventBus.$emit('showInputUrlDialog', param);
    }

    public hideInputUrlDialog() {
        this.eventBus.$emit('hideInputUrlDialog');
    }

    public showResetSyncConfirmDialog(param: CommonReasonDialogRequest) {
        this.eventBus.$emit('showResetSyncConfirmDialog', param);
    }

    public hideResetSyncConfirmDialog() {
        this.eventBus.$emit('hideResetSyncConfirmDialog');
    }

    public showPopupNoticesDialog(params: PopupNoticesDialogRequest): void {
        this.eventBus.$emit('showPopupNoticesDialog', params);
    }

    public hidePopupNoticesDialog(): void {
        this.eventBus.$emit('hidePopupNoticesDialog');
    }

    public showCaseNsdeSelectDialog(param: CaseNsdeDictionaryDialogRequest): void {
        this.eventBus.$emit('showCaseNsdeSelectDialog', param);
    }
    
    public hideCaseNsdeSelectDialog(): void {
        this.eventBus.$emit('hideCaseNsdeSelectDialog');
    }
    
    public showCaseUniiSelectDialog(param: CaseUniiDictionaryDialogRequest) {
        this.eventBus.$emit('showCaseUniiSelectDialog', param);
    }

    public hideCaseUniiSelectDialog() {
        this.eventBus.$emit('hideCaseUniiSelectDialog');
    }
    
    public showCaseDeviceProblemCodeSelectDialog(param: CaseDeviceProblemCodeDictionaryDialogRequest) {
        this.eventBus.$emit('showCaseDeviceProblemCodeSelectDialog', param);
    }
    
    public hideCaseDeviceProblemCodeSelectDialog() {
        this.eventBus.$emit('hideCaseDeviceProblemCodeSelectDialog');
    }
    
    public showCaseDeviceComponentCodeSelectDialog(param: CaseDeviceComponentCodeDictionaryDialogRequest) {
        this.eventBus.$emit('showCaseDeviceComponentCodeSelectDialog', param);
    }
    
    public hideCaseDeviceComponentCodeSelectDialog() {
        this.eventBus.$emit('hideCaseDeviceComponentCodeSelectDialog');
    }

    public showSyncOptionsDialog(param: SyncOptionsDialogRequest) {
        this.eventBus.$emit('showSyncOptionsDialog', param);
    }

    public hideSyncOptionsDialog() {
        this.eventBus.$emit('hideSyncOptionsDialog');
    }

    public showAiCodingUpdateConfirmDialog(param: AiCodingUpdateConfirmDialogRequest) {
        this.eventBus.$emit('showAiCodingUpdateConfirmDialog', param);
    }

    public hideAiCodingUpdateConfirmDialog() {
        this.eventBus.$emit('hideAiCodingUpdateConfirmDialog');
    }

    public showProductRecommendedCodeInfoDialog(param: ProductRecommendedCodeInfoDialogRequest) {
        this.eventBus.$emit('showProductRecommendedCodeInfoDialog', param);
    }

    public hideProductRecommendedCodeInfoDialog() {
        this.eventBus.$emit('hideProductRecommendedCodeInfoDialog');
    }

    public showWhoddSubstanceRecommendedCodeInfoDialog(param: WhoddSubstanceRecommendedCodeInfoDialogRequest) {
        this.eventBus.$emit('showWhoddSubstanceRecommendedCodeInfoDialog', param);
    }

    public hideWhoddSubstanceRecommendedCodeInfoDialog() {
        this.eventBus.$emit('hideWhoddSubstanceRecommendedCodeInfoDialog');
    }

    public showMfdsProductRecommendedCodeInfoDialog(param: MfdsProductRecommendedCodeInfoDialogRequest): void {
        this.eventBus.$emit('showMfdsProductRecommendedCodeInfoDialog', param);
    }

    public hideMfdsProductRecommendedCodeInfoDialog(): void {
        this.eventBus.$emit('hideMfdsProductRecommendedCodeInfoDialog');
    }

    public showMfdsSubstanceRecommendedCodeInfoDialog(params: MfdsSubstanceRecommendedCodeInfoDialogRequest) {
        this.eventBus.$emit('showMfdsSubstanceRecommendedCodeInfoDialog', params);
    }

    public hideMfdsSubstanceRecommendedCodeInfoDialog() {
        this.eventBus.$emit('hideMfdsSubstanceRecommendedCodeInfoDialog');
    }

    public showCaseWorkflowBatchUpdateDialog(param: CaseWorkflowBatchUpdateDialogRequest) {
        this.eventBus.$emit('showCaseWorkflowBatchUpdateDialog', param);
    }

    public hideCaseWorkflowBatchUpdateDialog() {
        this.eventBus.$emit('hideCaseWorkflowBatchUpdateDialog');
    }

    public getEventBus(): Vue {
        return this.eventBus;
    }
}

Vue.use(new ModalServiceImpl());
